import React, {useState, useEffect, useRef} from "react"
import PropTypes from "prop-types"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  Table,
  Row,
  Col, Input, Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container, Card, CardBody, CardTitle, CardText
} from "reactstrap"
import axios from "axios"
import * as url from "../../helpers/url_helper"
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link, useHistory, useParams } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import MetaTags from 'react-meta-tags'; 

const PersonalData = () => {
    const {id} = useParams()
    const history = useHistory();
    toastr.options = TOAST_OPTIONS;


    const [isEdit, setIsEdit] = useState(false);
    const [status, setStatus] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const [staffNo, setStaffNo]     = useState('WBH-')
    const [NIN, setNIN]             = useState('')
    const [title, setTitle]         = useState('')
    const [fName, setFName]         = useState('')
    const [mName, setMName]         = useState('')
    const [lName, setLName]         = useState('')
    const [gender, setGender]       = useState('')
    const [dob, setDOB]             = useState('')
    const [pob, setPOB]             = useState('')
    const [mStatus, setMStatus]     = useState('')
    const [userId, setUserId]       = useState('')

    const [father, setFather]       = useState('')
    const [mother, setMother]       = useState('')
    const [religion, setReligion]   = useState('')
    const [nationality, setNationality] = useState('')
    const [residentialAddress, setResidentialAddress] = useState('')
    const [residentialPhone, setResidentialPhone] = useState('')
    const [officePhone, setOfficePhone] = useState('')
    const [cellPhone, setCellPhone] = useState('')
    const [email, setEmail] = useState('')
    const [personalDoctor, setPersonalDoctor] = useState('')
    const [bloodGroup, setBloodGroup] = useState('')
    const [allergies, setAllergies] = useState('')

    const [kinName, setKinName] = useState('')
    const [kinRelation, setKinRelation] = useState('')
    const [kinAddress, setKinAddress] = useState('')
    const [kinPhone, setKinPhone] = useState('')
    const [kinEmail, setKinEmail] = useState('')

    const [employeeStatus, setEmployeeStatus] = useState('Active')
    const [dateTimeAdded, setdateTimeAdded] = useState('')
    const [jobDate, setJobDate] = useState('')
    const [jobTitleId, setJobTitleId] = useState('')
    const [jobTitleName, setJobTitleName] = useState('')
    const [reportsToId, setReportsToId] = useState('')
    const [deptId, setDeptId] = useState('')
    const [deptName, setDeptName] = useState('')
    const [locationId, setLocationId] = useState('')
    const [locationName, setLocationName] = useState('')
    const [employementType, setEmploymentType] = useState('')
    const [contractNo, setContractNo] = useState('')
    const [contractStart, setContractStart] = useState('')
    const [contractEnd, setContractEnd] = useState('')

    const [econtracts, setEContracts] = useState([])
    const [eDependants, setEDependants] = useState([])
    const [eEducation, setEEducation] = useState([])
    const [eExperience, setEExperience] = useState([])
    const [eJHistory, setEJHistory] = useState([])
    const [eLanguages, setELanguages] = useState([])
    const [eLicenses, setELicenses] = useState([])
    const [ePassports, setEPassports] = useState([])
    const [eSkills, setESkills] = useState([])
    const [eMemberships, setEMemberships] = useState([])
    const [eSalary, setESalary] = useState([])
    const [eAssets, setEAssets] = useState([])

    const [contractOptions, setContractOptions]     = useState([
                                                        "Permanent",
                                                        "Fixed-Term",
                                                        "Casual",
                                                        "Temporary",
                                                        "Probationary",
                                                        "Freelance or Independent",
                                                        "Zero-Hours",
                                                        "Part-Time",
                                                        "Seasonal",
                                                        "Apprenticeship or Trainee",
                                                        "Work-for-Hire Agreement",
                                                        "Retainer Agreement",
                                                        "Commission-Based",
                                                        "Volunteer or Unpaid Internship",
                                                        "On-Call",
                                                        "Consultancy Agreement"
                                                    ])
    const [titleOptions, setTitleOptions]     = useState(['Mr', 'Mrs', 'Miss', 'Dr', 'Eng'])
    const [genderOptions, setGenderOptions]   = useState(['Male', 'Female'])
    const [maritalOptions, setMaritalOptions] = useState(['Single', 'Married', 'Divorced', 'Separated'])
    const [relationOptions, setRelationOptions] = useState(['Mother', 'Father', 'Wife', 'Husband','Brother','Sister','Uncle','Aunt','Niece','Nephew','Cousin','Son','Daughter'])
    const [dependantOptions, setDependantOptions] = useState(['Wife', 'Husband','Son','Daughter'])
    const [religionOptions, setReligionOptions] = useState(['Islam', 'Othodox', 'Catholic','Protestant','Others'])
    const [bloodOptions, setBloodOptions] = useState(['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'])
    const [employeeStatusOptions, setEmployeeStatusOptions]     = useState(['Active', 'Suspended', 'Terminated'])
    const [educationTypeOptions, setEducationTypeOptions] = useState(['O level','A Level', 'Tertiary', 'Diploma','Higher Diploma', 'Bachelor\'s Degree', 'Postgraduate Diploma','Masters Degree', 'PhD'])
    const [employmentTypeOptions, setEmploymentTypeOptions] = useState(['Freelance','Full-Time Contract','Full-Time Permanent','Full-Time Probation','Part-Time Contract','Part-Time Internship'])
    const [jobTitleOptions, setJobTitleOptions]     = useState([])
    const [jobDeptOptions, setJobDeptOptions]     = useState([])
    const [filecategoryOptions, setFileCategoryOptions] = useState(['Appointment Letter','Contract','Qualifications','Dependants','Marriage Documents','Certificates','Licenses','Memberships','Passports'])
    const [jobLocationOptions, setJobLocationOptions]     = useState([])
    const [langProfOptions, setLangProfOptions]     = useState(["Basic", "Conversational", "Fluent", "Native"])
    const [nationalityOptions, setNationalityOptions]     = useState(['SOMALILAND','SOMALIA','UGANDA'])
    const [passTypeOptions, setPassTypeOptions] = useState(["Regular Passport", "Diplomatic Passport", "Official Passport", "Service Passport", "Emergency Passport", "Temporary Passport", "Collective Passport", "Special Passport", "Travel Document", "Seaman Passport"])
    const [companyCategoriesOptions, setCompanyCategoriesOptions] = useState([
                                                                            "Information Technology",
                                                                            "Healthcare",
                                                                            "Finance and Banking",
                                                                            "Education",
                                                                            "Manufacturing",
                                                                            "Retail",
                                                                            "Hospitality and Tourism",
                                                                            "Construction",
                                                                            "Transportation and Logistics",
                                                                            "Telecommunications",
                                                                            "Government and Public Administration",
                                                                            "Non-Profit and NGOs",
                                                                            "Energy and Utilities",
                                                                            "Media and Entertainment",
                                                                            "Pharmaceuticals and Biotechnology",
                                                                            "Real Estate",
                                                                            "Legal Services",
                                                                            "Agriculture and Farming",
                                                                            "Automotive",
                                                                            "Aerospace and Defense",
                                                                            "Fashion and Apparel",
                                                                            "Food and Beverage",
                                                                            "Consulting and Professional Services",
                                                                            "Environmental Services"
                                                                        ]);
    
    const [modal_assign, setmodal_assign] = useState(false)
    const [modal_file, setmodal_file] = useState(false);
    const [modal_dependants, setmodal_dependants] = useState(false)
    const [modal_contracts, setmodal_contracts] = useState(false)
    const [modal_education, setmodal_education] = useState(false)
    const [modal_experiences, setmodal_experiences] = useState(false)
    const [modal_jhistory, setmodal_jhistory] = useState(false)
    const [modal_languages, setmodal_languages] = useState(false)
    const [modal_licenses, setmodal_licenses] = useState(false)
    const [modal_passports, setmodal_passports] = useState(false)
    const [modal_skills, setmodal_skills] = useState(false)
    const [modal_memberships, setmodal_memberships] = useState(false)
    const [modal_salary, setmodal_salary] = useState(false)
    const [modal_asset, setmodal_asset] = useState(false)

    const [lineId, setLineId] = useState('')
    const [dependantName, setDependantName] = useState('')
    const [dependantRelation, setDependantRelation] = useState('')
    const [dependantBirthdate, setDependantBirthdate] = useState([])
    const [dependantGender, setDependantGender] = useState('')
    const [dependantMedical, setDependantMedical] = useState('No')

    const [qualificationType, setQualificationType] = useState('')
    const [qualificationName, setQualificationName] = useState('')
    const [qualificationInstitution, setQualificationInstitution] = useState('')
    const [qualificationPeriod, setQualificationPeriod] = useState('')

    const [jobHDate, setJobHDate] = useState([])
    const [jobHTitle, setJobHTitle] = useState('')
    const [jobHDept, setJobHDept] = useState('')
    const [jobHLocation, setJobHLocation] = useState('')
    const [jobHType, setJobHType] = useState('')

    const [skillName, setSkillName] = useState('')

    const [licenseName, setLicenseName] = useState('')
    const [licenseNo, setLicenseNo] = useState('')
    const [licenseIssueDate, setLicenseIssueDate] = useState([])
    const [licenseExpiryDate, setLicenseExpiryDate] = useState([])

    const [expCompanyType, setExpCompanyType] = useState('')
    const [expCompanyName, setExpCompanyName] = useState('')
    const [expPosition, setExpPosition] = useState('')
    const [expFrom, setExpFrom] = useState([])
    const [expTo, setExpTo] = useState([])

    const [membershipBody, setMembershipBody] = useState('')
    const [membershipNo, setMembershipNo] = useState('')

    const [passNo, setPassNo] = useState('')
    const [passType, setPassType] = useState('')
    const [passIssueDate, setPassIssuedate] = useState([])
    const [passIssuePlace, setPassIssuePlace] = useState('')
    const [passExpireDate, setPassExpiredate] = useState([])

    const [langName, setLangName] = useState('')
    const [langProf, setLangProf] = useState('')

    const [contNo, setContNo] = useState('')
    const [contType, setContType] = useState('')
    const [contFrom, setContFrom] = useState([])
    const [contTo, setContTo] = useState([])

    const [documentCategory, setDocumentCategory] = useState('')
    const [documentName, setDocumentName] = useState('')
    const [loadingFiles, setLoadingFiles] = useState(false)
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [selectedFile, setSelectedFile] = useState([])

    const [salaryId, setSalaryId] = useState('')
    const [salaryDate, setSalaryDate] = useState([])
    const [salaryOptions, setSalaryOptions] = useState([])

    const [assetName, setAssetName] = useState('')
    const [assetDetails, setAssetDetails] = useState([])
    const [assetDate, setAssetDate] = useState([])

    const [dataFound, setDataFound] = useState(false)

    const removeBodyCss = () => {
        document.body.classList.add("no_padding");
    }
    const tog_asset = () => {
        setmodal_asset(!modal_asset);
        removeBodyCss();
      }
    const tog_salary = () => {
        setmodal_salary(!modal_salary);
        removeBodyCss();
    }
    const tog_file = () => {
      setmodal_file(!modal_file);
      removeBodyCss();
    }
    const tog_dependant = () => {
        setmodal_dependants(!modal_dependants);
        removeBodyCss();
    }
    const tog_contracts = () => {
        setmodal_contracts(!modal_contracts);
        removeBodyCss();
    }
    const tog_education = () => {
        setmodal_education(!modal_education);
        removeBodyCss();
    }
    const tog_experience = () => {
        setmodal_experiences(!modal_experiences);
        removeBodyCss();
    }
    const tog_jhistory = () => {
        setmodal_jhistory(!modal_jhistory);
        removeBodyCss();
    }
    const tog_language = () => {
        setmodal_languages(!modal_languages);
        removeBodyCss();
    }
    const tog_licenses = () => {
        setmodal_licenses(!modal_licenses);
        removeBodyCss();
    }
    const tog_passports = () => {
        setmodal_passports(!modal_passports);
        removeBodyCss();
    }
    const tog_skills = () => {
        setmodal_skills(!modal_skills);
        removeBodyCss();
    } 
    const tog_memberships = () => {
        setmodal_memberships(!modal_memberships);
        removeBodyCss();
    } 
   
    const fetchData = () => {
        const obj = JSON.parse(localStorage.getItem("authWTUser"));
        if(obj.hrNo){
             setDataFound(true)
             const data = {
                 id  : '',
                 no  : obj.hrNo,
                 name: '',
                 sex : '',
                 dept: '',
                 category: '',
                 location: ''
             }
            setIsLoading(true)
            axios.post(url.HREMPLOYEESFILTER, JSON.stringify(data), Config).then((r)=>{
                if(r.data[0]){
                    const x = r.data[0]
                    setStaffNo(x.no?x.no:'')
                    setNIN(x.nin?x.nin:'')
                    setTitle(x.title?x.title:'')
                    setFName(x.firstName?x.firstName:'')
                    setMName(x.middleName?x.middleName:'')
                    setLName(x.surname?x.surname:'')
                    setGender(x.sex?x.sex:'')
                    setDOB(x.dob?[new Date(x.dob)]: '')
                    setPOB(x.pob?x.pob:'')
                    setMStatus(x.maritalStatus?x.maritalStatus:'')
                    setMother(x.mother?x.mother:'')
                    setFather(x.father?x.father:'')
                    setReligion(x.religion?x.religion:'')
                    setNationality(x.nationality?x.nationality:'')
                    setResidentialAddress(x.residentialAddress?x.residentialAddress:'') 
                    setResidentialPhone(x.residentialPhone?x.residentialPhone:'')
                    setOfficePhone(x.officePhone?x.officePhone:'')
                    setCellPhone(x.cellPhone?x.cellPhone:'')
                    setEmail(x.email?x.email:'')
                    setPersonalDoctor(x.personalDoctor?x.personalDoctor:'')
                    setBloodGroup(x.bloodGroup?x.bloodGroup:'')
                    setAllergies(x.allergies?x.allergies:'')
                    setKinName(x.kinName?x.kinName:'')
                    setKinRelation(x.kinRelation?x.kinRelation:'')
                    setKinAddress(x.kinAddress?x.kinAddress:'')
                    setKinPhone(x.kinPhone?x.kinPhone:'')
                    setKinEmail(x.kinEmail?x.kinEmail:'')
                    setEmployeeStatus(x.employeeStatus?x.employeeStatus:'')
                    setdateTimeAdded(x.dateTimeAdded?x.dateTimeAdded:'')
                    setJobDate(x.jobDate?x.jobDate:'')
                    setJobTitleId(x.jobTitleId?x.jobTitleId:'')
                    setJobTitleName(x.jobTitleName?x.jobTitleName:'')
                    setReportsToId(x.reportsToId?x.reportsToId:'')
                    setDeptId(x.deptId?x.deptId:'')
                    setDeptName(x.deptName?x.deptName:'')
                    setLocationId(x.locationId?x.locationId:'')
                    setLocationName(x.locationName?x.locationName:'')
                    setEmploymentType(x.employementType?x.employementType:'')
                    setContractNo(x.contractNo?x.contractNo:'')
                    setContractStart(x.contractStart?x.contractStart:'')
                    setContractEnd(x.contractEnd?x.contractEnd:'')
                    setEContracts(x.listContracts)
                    setEDependants(x.listDependants)
                    setEEducation(x.listEducation)
                    setEExperience(x.listExperience)
                    setEJHistory(x.listHistory)
                    setELanguages(x.listLanguages)
                    setELicenses(x.listLicences)
                    setEPassports(x.listPassports)
                    setESkills(x.listSkills)
                    setEMemberships(x.listMemberships)
                    setUploadedFiles(x.listFiles)
                    setESalary(x.listScales)
                    setEAssets(x.listAssets)
                }
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }else{
            setDataFound(false)
        }
    }

    useEffect(() => {
        if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
        }
        axios.get(url.DEPTS, Config).then((r)=>{ setJobDeptOptions(r.data);}).catch((e)=>console.log(e))
        axios.get(url.TITLES, Config).then((r)=>{ setJobTitleOptions(r.data); }).catch((e)=>console.log(e))
        axios.get(url.HRLOCATIONS, Config).then((r)=>{ setJobLocationOptions(r.data); }).catch((e)=>{  console.log(e); });
        axios.get(url.HRPAYSCALES, Config).then((r)=>{ setSalaryOptions(r.data); }).catch((e)=>{ console.log(e)})
        fetchData();
    },[]);

    const handleUpdate = () =>{
        const data = {
            id                  : be.decryptId(id),
            no                  : staffNo,
            nin                 : NIN,
            title               : title,
            surname             : lName,
            firstName           : fName,
            middleName          : mName,
            sex                 : gender,
            dob                 : (dob != "")?formatDate(dob):"",
            pob                 : pob,
            status              : mStatus,
            fatherName          : father,
            motherName          : mother,
            religion            : religion,
            nationality         : nationality,
            residentialAddress  : residentialAddress,
            residentialPhone    : residentialPhone,
            officePhone         : officePhone,
            cellPhone           : cellPhone,
            email               : email,
            personalDoctor      : personalDoctor,
            bloodGroup          : bloodGroup,
            allergies           : allergies,
            kinName             : kinName,
            kinRelation         : kinRelation,
            kinAddress          : kinAddress,
            kinPhone            : kinPhone,
            kinEmail            : kinEmail,
            employeeStatus      : employeeStatus,
            userId              : userId,
            action              : "edit"
          }
          setIsLoading(true)
          axios.post(url.HREMPLOYEES, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == "1"){
              toastr.success(r.data.message)
              fetchData()
            }else{
              toastr.error(r.data.message)
            }
          }).catch((e)=>{
            console.log(e)
          }).finally(()=>{
            setIsLoading(false)
          })
    }
    const handleDelete = () =>{
        const data = {
            id                  : be.decryptId(id),
            no                  : staffNo,
            nin                 : NIN,
            title               : title,
            surname             : lName,
            firstName           : fName,
            middleName          : mName,
            sex                 : gender,
            dob                 : "",
            pob                 : pob,
            status              : mStatus,
            fatherName          : father,
            motherName          : mother,
            religion            : religion,
            nationality         : nationality,
            residentialAddress  : residentialAddress,
            residentialPhone    : residentialPhone,
            officePhone         : officePhone,
            cellPhone           : cellPhone,
            email               : email,
            personalDoctor      : personalDoctor,
            bloodGroup          : bloodGroup,
            allergies           : allergies,
            kinName             : kinName,
            kinRelation         : kinRelation,
            kinAddress          : kinAddress,
            kinPhone            : kinPhone,
            kinEmail            : kinEmail,
            employeeStatus      : employeeStatus,
            userId              : userId,
            action              : "delete"
          }
          setIsLoading(true)
          axios.post(url.HREMPLOYEES, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == "1"){
              toastr.success(r.data.message)
              history.push('/employees')
            }else{
              toastr.error(r.data.message)
            }
          }).catch((e)=>{
            console.log(e)
          }).finally(()=>{
            setIsLoading(false)
          })
    }
    const handleSaveDependant = () =>{
        const data = {
            id      : isEdit?lineId:'',
            empId   : be.decryptId(id),
            type    : dependantRelation,  
            name    : dependantName,
            dob     : formatDate(dependantBirthdate[0]),
            gender  : dependantGender,
            onMedical: dependantMedical,
            action   : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEDEPLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_dependant()
                toastr.success(r.data.message)
                setDependantBirthdate([])
                setDependantGender('')
                setDependantMedical('No')
                setDependantName('')
                setDependantRelation('')
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditDependants = (l) =>{
        tog_dependant()
        setIsEdit(true)
        setLineId(l.id)
        setDependantRelation(l.type)
        setDependantName(l.name)
        setDependantGender(l.gender)
        setDependantBirthdate([new Date(l.dob)])
        setDependantMedical(l.onMedical)
    }
    const handleDeleteDependant = (l) =>{
        const data = {
            id      : l.id,
            empId   : be.decryptId(id),
            type    : '',  
            name    : '',
            dob     : '',
            gender  : '',
            onMedical: '',
            action   : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEDEPLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }

    const handleSaveEducation = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            level       : qualificationType,  
            name        : qualificationName,
            institution : qualificationInstitution,
            startEnd    : qualificationPeriod,
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEEDUCLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_education()
                toastr.success(r.data.message)
                setQualificationType('')
                setQualificationName('')
                setQualificationInstitution('')
                setQualificationPeriod('')
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }

    const handleEditEducation = (l) =>{
        tog_education();
        setIsEdit(true)
        setLineId(l.id)
        setQualificationType(l.level)
        setQualificationName(l.qualification)
        setQualificationInstitution(l.institution)
        setQualificationPeriod(l.startEnd)
    }
    const handleDeleteEducation = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            level       : '',  
            name        : '',
            institution : '',
            startEnd    : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEEDUCLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveJobDetails = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            date        : jobHDate?formatDate(jobHDate[0]):'',  
            titleId     : jobHTitle,
            locationId  : jobHLocation,
            deptId      : jobHDept,
            type        : jobHType,
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEHISTLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_jhistory()
                toastr.success(r.data.message)
                setJobHDate([])
                setJobHTitle('')
                setJobHLocation('')
                setJobHDept('')
                setJobHType('')
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditJobH = (l) =>{
        setIsEdit(true)
        setLineId(l.id)
        setJobHDate([new Date(l.date)])
        setJobHDept(l.deptId)
        setJobHTitle(l.titleId)
        setJobHLocation(l.locationId)
        setJobHType(l.employmentType)
        tog_jhistory()
    }
    const handleDeleteJobH = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            date        : '',  
            titleId     : '',
            locationId  : '',
            deptId      : '',
            type        : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEHISTLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveSkills = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            skill       : skillName,
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEESKILLLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_skills()
                toastr.success(r.data.message)
                setSkillName('')
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditSkill = (l) =>{
        setSkillName(l.skill)
        setLineId(l.id)
        setIsEdit(true)
        tog_skills()
    }
    const handleDeleteSkill = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            skill       : '',  
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEESKILLLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveLicense = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            name        : licenseName,
            no          : licenseNo,
            dateIssued  : licenseIssueDate?formatDate(licenseIssueDate):'',
            expiryDate  : licenseExpiryDate?formatDate(licenseExpiryDate):'',
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEELICELINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_licenses()
                toastr.success(r.data.message)
                setLicenseNo('')
                setLicenseName('')
                setLicenseIssueDate([])
                setLicenseExpiryDate([])
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditLicense = (l) =>{
        setIsEdit(true)
        setLineId(l.id)
        setLicenseName(l.licence)
        setLicenseNo(l.no)
        setLicenseIssueDate([new Date(l.issuedOn)])
        setLicenseExpiryDate([new Date(l.expireOn)])
        tog_licenses()
    }
    const handleDeleteLicense = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            name        : '',
            no          : '',
            dateIssued  : '',
            expiryDate  : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEELICELINE, JSON.stringify(data), Config).then((r)=>{
             console.log(r)
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveExperience = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            type        : expCompanyType,
            name        : expCompanyName,
            position    : expPosition,
            from        : expFrom?formatDate(expFrom):'',
            to          : expTo?formatDate(expTo):'',
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEEXPLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_experience()
                toastr.success(r.data.message)
                setExpCompanyType('')
                setExpCompanyName('')
                setExpPosition('')
                setExpFrom([])
                setExpTo([])
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditExperience = (l) =>{
        setIsEdit(true)
        tog_experience()
        setLineId(l.id)
        setExpCompanyName(l.employer)
        setExpCompanyType(l.type)
        setExpPosition(l.position)
        setExpFrom([new Date(l.from)])
        setExpTo([new Date(l.to)])
    }
    const handleDeleteExperience = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            type        : '',
            name        : '',
            position    : '',
            from        : '',
            to          : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEEXPLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveMembership = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            organisation: membershipBody,
            regno       : membershipNo,
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEMEMBERLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_memberships()
                toastr.success(r.data.message)
                setMembershipBody('')
                setMembershipNo('')
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditMembership = (l) =>{
        tog_memberships()
        setIsEdit(true)
        setLineId(l.id)
        setMembershipBody(l.organisation)
        setMembershipNo(l.regno)
    }
    const handleDeleteMembership = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            organisation: '',
            regno       : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEMEMBERLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSavePassport = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            no          : passNo,
            type        : passType,
            dateIssued  : passIssueDate?formatDate(passIssueDate[0]):'',
            place       : passIssuePlace,
            expiryDate  : passExpireDate?formatDate(passExpireDate[0]):'',
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEPASSPORTLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_passports()
                toastr.success(r.data.message)
                setPassNo('')
                setPassType('')
                setPassIssuePlace('')
                setPassIssuedate([])
                setPassExpiredate([])
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditPassport = (l) =>{
        setIsEdit(true)
        tog_passports()
        setLineId(l.id)
        setPassNo(l.no)
        setPassType(l.type)
        setPassIssuePlace(l.placeIssued)
        setPassIssuedate([new Date(l.issuedOn)])
        setPassExpiredate([new Date(l.expireOn)])
    }
    const handleDeletePassport = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            no          : '',
            type        : '',
            dateIssued  : '',
            place       : '',
            expiryDate  : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEPASSPORTLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveLanguage = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            language    : langName,
            proficiency : langProf,
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEELANGLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_language()
                toastr.success(r.data.message)
                setLangName('')
                setLangProf('')
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditLanguage = (l)=>{
        setIsEdit(true)
        setLineId(l.id)
        setLangName(l.language)
        setLangProf(l.proficiency)
        tog_language()
    }
    const handleDeleteLanguage = (l)=>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            language    : '',
            proficiency : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEELANGLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveContract = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            contractType: contType,
            contractNo  : contNo,
            contractStart: contFrom?formatDate(contFrom[0]):'',
            contractEnd : contTo?formatDate(contTo[0]):'',
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEESCONTRACTLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_contracts()
                toastr.success(r.data.message)
                setContType('')
                setContNo('')
                setContFrom([])
                setContTo([])
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleEditContract = (l) =>{
        setLineId(l.id)
        setIsEdit(true)
        tog_contracts()
        setContType(l.type)
        setContNo(l.no)
        setContFrom([new Date(l.start)])
        setContTo([new Date(l.end)])
    }
    const handleDeleteContract = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            contractNo  : '',
            contractStart: '',
            contractEnd : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEESCONTRACTLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }

    const handleAddFile = () =>{
        if(selectedFile.length > 0){
            selectedFile.forEach((f)=>{
              const reader = new FileReader();
              reader.readAsDataURL(f);
              reader.onloadend = () => {
                  const base64Data = reader.result;
                  const fileName = f.name;
                  const fileExtension = fileName.split('.').pop();
                  const fileData = {
                        documentCategory: documentCategory,
                        documentName    : documentName,
                        action          :"add",
                        empId           : be.decryptId(id),
                        FileName        :fileName,
                        FileExtension   : fileExtension,
                        fileContentType :be.getContentTypeFromBase64(base64Data),
                        FileContentsBase64:base64Data.split(',')[1]
                  }
    
                  setIsLoading(true)
                  axios.post(url.HREMPLOYEEFILES, JSON.stringify(fileData), Config).then((rf)=>{
                    toastr.success(rf.data.message)
                    setDocumentCategory('')
                    setDocumentName('')
                    tog_file()
                    fetchData()
                  }).catch((ef)=>{ 
                      console.log(ef)
                      setIsLoading(false)
                  })
                  
              }
            })
          }
    }
    const handleDownload = (f)=>{
        const urlx = url.APACHE_URL+"/attach/"+ f.location
        axios({
            url: urlx,
            method: 'GET',
            responseType: 'blob',
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', f.location);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error('Error downloading the file:', error);
          });
      }
      const removeFile = (f) =>{
        const data = {
          action:"delete",
          fId: f.id,
          fName: f.location
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEFILES, JSON.stringify(data), Config).then((rf)=>{
          toastr.success(rf.data.message)
          fetchData()
        }).catch((ef)=>{ 
            console.log(ef)
            setIsLoading(false)
        })
      }
      const handleSaveSalary = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            scaleId     : salaryId,
            scaleDate   : salaryDate?formatDate(salaryDate[0]):'',
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEPAYLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_salary()
                toastr.success(r.data.message)
                setSalaryId('')
                setSalaryDate([])
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
      }
    const handleDeleteScale = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            scaleId     : '',
            scaleDate   : '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEPAYLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    const handleSaveAsset = () =>{
        const data = {
            id          : isEdit?lineId:'',
            empId       : be.decryptId(id),
            equipment   : assetName,
            details     : assetDetails,
            assignedDate: assetDate?formatDate(assetDate[0]):'',
            action      : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEASSETLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                tog_asset()
                toastr.success(r.data.message)
                setAssetName('')
                setAssetDate([])
                setAssetDetails('')
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
      }
      const handleDeleteAsset = (l) =>{
        const data = {
            id          : l.id,
            empId       : be.decryptId(id),
            equipment   : '',
            details     : '',
            assignedDate: '',
            action      : 'delete'
        }
        setIsLoading(true)
        axios.post(url.HREMPLOYEEASSETLINE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData();
            }else{
                toastr.error(r.data.message)
            }
        }).catch((e)=>{
            console.log(e)
        }).finally((r)=>{
            setIsLoading(false)
        })
    }
    return (
        <>
        <LoadingOverlay
            active={isLoading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
                <MetaTags>
                <title>Employee Details | {url.COMPANY}</title>
                </MetaTags>
                <Container fluid={true}>
                    <div>
                        <Row>
                                <Modal isOpen={modal_asset} toggle={() => { tog_asset()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Company Assets Assigned` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_asset(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Asset Name e.g. Motorcycle, car, laptop...</label>
                                            <input type='text' className="form-control" value={assetName} onChange={(e)=>setAssetName(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Date assigned</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={assetDate}
                                                onChange={(dates)=>{setAssetDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Asset Details (Specifications and Condition)</label>
                                            <textarea className="form-control" value={assetDetails} onChange={(e)=>setAssetDetails(e.target.value)} />
                                        </div>
                                    </Col>
                                    
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_asset() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveAsset} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_salary} toggle={() => { tog_salary()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Employee Salary` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_salary(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Salary Scale</label>
                                            <select className="form-select" value={salaryId} onChange={(e)=>setSalaryId(e.target.value)}>
                                                <option value=''></option>
                                                  {(salaryOptions || []).map((t,k)=>(
                                                    <option key={k} value={t.id}>{t.name}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Date</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={salaryDate}
                                                onChange={(dates)=>{setSalaryDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_salary() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveSalary} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_contracts} toggle={() => { tog_contracts()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Employee Contracts` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_contracts(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Contract Type</label>
                                            <select className="form-select" value={contType} onChange={(e)=>setContType(e.target.value)}>
                                                <option value=''></option>
                                                  {(contractOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Contract Number</label>
                                            <input type='text' className="form-control" value={contNo} onChange={(e)=>setContNo(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>From</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={contFrom}
                                                onChange={(dates)=>{setContFrom(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Till</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={contTo}
                                                onChange={(dates)=>{setContTo(dates); }}
                                                />
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_contracts() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveContract} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_languages} toggle={() => { tog_language()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Languages` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_languages(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                 
                                  <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Language</label>
                                            <input type='text' className="form-control" value={langName} onChange={(e)=>setLangName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Proficiency</label>
                                            <select className="form-select" value={langProf} onChange={(e)=>setLangProf(e.target.value)}>
                                                <option value=''></option>
                                                  {(langProfOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_language() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveLanguage} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_passports} toggle={() => { tog_passports()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Passport` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_passports(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                 
                                  <Row > 
                                    
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Passport Number</label>
                                            <input type='text' className="form-control" value={passNo} onChange={(e)=>setPassNo(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Passport Type</label>
                                            <select className="form-select" value={passType} onChange={(e)=>setPassType(e.target.value)}>
                                                <option value=''></option>
                                                  {(passTypeOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Issued on</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={passIssueDate}
                                                onChange={(dates)=>{setPassIssuedate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Issued at (Place)</label>
                                            <input type='text' className="form-control" value={passIssuePlace} onChange={(e)=>setPassIssuePlace(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Expires on</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={passExpireDate}
                                                onChange={(dates)=>{setPassExpiredate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_passports() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSavePassport} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_memberships} toggle={() => { tog_memberships()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Membership to Professional Bodies` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_memberships(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                 
                                  <Row > 
                                    
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Organisation/body</label>
                                            <input type='text' className="form-control" value={membershipBody} onChange={(e)=>setMembershipBody(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Registration number</label>
                                            <input type='text' className="form-control" value={membershipNo} onChange={(e)=>setMembershipNo(e.target.value)}/>
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_memberships() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveMembership} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_experiences} toggle={() => { tog_experience()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Working Experience` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_experiences(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                 
                                  <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Company/Organisation type</label>
                                            <select className="form-select" value={expCompanyType} onChange={(e)=>setExpCompanyType(e.target.value)}>
                                                <option value=''></option>
                                                  {(companyCategoriesOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Company/Organisation name</label>
                                            <input type='text' className="form-control" value={expCompanyName} onChange={(e)=>setExpCompanyName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Position held</label>
                                            <input type='text' className="form-control" value={expPosition} onChange={(e)=>setExpPosition(e.target.value)}/>
                                        </div>
                                    </Col>
                                 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>From</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={expFrom}
                                                onChange={(dates)=>{setExpFrom(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>To</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={expTo}
                                                onChange={(dates)=>{setExpTo(dates); }}
                                            />
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_experience() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveExperience} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_licenses} toggle={() => { tog_licenses()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Employee Licenses` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_licenses(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>License Name</label>
                                            <input type='text' className="form-control" value={licenseName} onChange={(e)=>setLicenseName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>License Number</label>
                                            <input type='text' className="form-control" value={licenseNo} onChange={(e)=>setLicenseNo(e.target.value)}/>
                                        </div>
                                    </Col>
                                 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Date Issued</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={licenseIssueDate}
                                                onChange={(dates)=>{setLicenseIssueDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Expiry Date</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={licenseExpiryDate}
                                                onChange={(dates)=>{setLicenseExpiryDate(dates); }}
                                            />
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_licenses() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveLicense} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_skills} toggle={() => { tog_skills()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Employee Skills` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_skills(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Skill description</label>
                                            <input type='text' className="form-control" value={skillName} onChange={(e)=>setSkillName(e.target.value)}/>
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_skills() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveSkills} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_jhistory} toggle={() => { tog_jhistory()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Job Details` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_jhistory(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                                  
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Appointment Date</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={jobHDate}
                                                onChange={(dates)=>{setJobHDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <select className="form-select" value={jobHTitle} onChange={(e)=>setJobHTitle(e.target.value)}>
                                                <option value=''></option>
                                                  {(jobTitleOptions || []).map((t,k)=>(
                                                    <option key={k} value={t.id}>{t.title}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Department</label>
                                            <select className="form-select" value={jobHDept} onChange={(e)=>setJobHDept(e.target.value)}>
                                                <option value=''></option>
                                                  {(jobDeptOptions || []).map((t,k)=>(
                                                    <option key={k} value={t.id}>{t.name}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Location</label>
                                            <select className="form-select" value={jobHLocation} onChange={(e)=>setJobHLocation(e.target.value)}>
                                                <option value=''></option>
                                                  {(jobLocationOptions || []).map((t,k)=>(
                                                    <option key={k} value={t.id}>{t.name}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Employment Type</label>
                                            <select className="form-select" value={jobHType} onChange={(e)=>setJobHType(e.target.value)}>
                                                <option value=''></option>
                                                  {(employmentTypeOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_jhistory() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveJobDetails} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_education} toggle={() => { tog_education()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Qualifications` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_education(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Type</label>
                                            <select className="form-select" value={qualificationType} onChange={(e)=>setQualificationType(e.target.value)}>
                                                <option value=''></option>
                                                  {(educationTypeOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Qualification</label>
                                            <input type='text' className="form-control" value={qualificationName} onChange={(e)=>setQualificationName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Institution</label>
                                            <input type='text' className="form-control" value={qualificationInstitution} onChange={(e)=>setQualificationInstitution(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>From - To (YYYY-YYYY)</label>
                                            <input type='text' className="form-control" value={qualificationPeriod} onChange={(e)=>setQualificationPeriod(e.target.value)}/>
                                        </div>
                                    </Col>
                                    
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_education() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveEducation} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_file} toggle={() => { tog_file()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `File(s)` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_file(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Document Category</label>
                                            <select className="form-select" value={documentCategory} onChange={(e)=>setDocumentCategory(e.target.value)}>
                                                <option value=''></option>
                                                  {(filecategoryOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Document Name</label>
                                            <input type='text' className="form-control" value={documentName} onChange={(e)=>setDocumentName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                    <div className="mb-3">
                                            <label htmlFor="floatingnameInput">Attach Files</label>
                                            <input type="file" multiple className="form-control"  onChange={(e)=>setSelectedFile(Array.from(e.target.files))}   />
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_file() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleAddFile}>Add file(s)...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_dependants} toggle={() => { tog_dependant()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Dependants` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_dependants(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Name</label>
                                            <input type='text' className="form-control" value={dependantName} onChange={(e)=>setDependantName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Relationship</label>
                                            <select className="form-select" value={dependantRelation} onChange={(e)=>setDependantRelation(e.target.value)}>
                                                <option value=''></option>
                                                  {(dependantOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Date of birth</label>
                                            <Flatpickr
                                                className="form-control form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={dependantBirthdate}
                                                onChange={(dates)=>{setDependantBirthdate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Gender</label>
                                            <select className="form-select" value={dependantGender} onChange={(e)=>setDependantGender(e.target.value)}>
                                                <option value=''></option>
                                                <option value='Male'>Male</option>
                                                <option value='Female'>Female</option>
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>On Medical Scheme</label>
                                            <select className="form-select" value={dependantMedical} onChange={(e)=>setDependantMedical(e.target.value)}>
                                                <option value=''></option>
                                                <option value='Yes'>Yes</option>
                                                <option value='No'>No</option>
                                            </select>
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_dependant() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveDependant} >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>
                                {dataFound?(<>
                            <Col  xl={12}>{(employeeStatus == 'Active')?(<Alert color='success'>Employment status : {employeeStatus}</Alert>):(employeeStatus == 'Suspended')?<Alert color='warning'>Employment status :  {employeeStatus}</Alert>:<Alert color='danger'>Employement status : {employeeStatus}</Alert>}</Col>
                        
                            <Col  xl={6}>
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Employee Details</h6>
                                <CardBody>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Staff No</label>
                                                <input type='text' className="form-control" disabled={true} value={staffNo} onChange={(e)=>setStaffNo(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>National ID No</label>
                                                <input type='text' className="form-control" value={NIN} disabled={true} onChange={(e)=>setNIN(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Title</label>
                                                <select className="form-select" value={title} disabled={true} onChange={(e)=>setTitle(e.target.value)}>
                                                  <option value=''></option>
                                                  {(titleOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>First Name</label>
                                                <input type='text' className="form-control" value={fName} disabled={true} onChange={(e)=>setFName(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Middle Name</label>
                                                <input type='text' className="form-control" value={mName} disabled={true} onChange={(e)=>setMName(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Surname (Last Name)</label>
                                                <input type='text' className="form-control" value={lName} disabled={true} onChange={(e)=>setLName(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Gender</label>
                                                <select className="form-select" value={gender} disabled={true} onChange={(e)=>setGender(e.target.value)}>
                                                  <option value=''></option>
                                                  {(genderOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Date of Birth</label>
                                                <Flatpickr
                                                    className="form-control form-control"
                                                    options={{
                                                        dateFormat: "Y-m-d",
                                                        enableTime: false
                                                    }}
                                                    value={dob}
                                                    onChange={(dates)=>{setDOB(dates)}}
                                                    />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Place of Birth</label>
                                                <input type='text' className="form-control" value={pob} onChange={(e)=>setPOB(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Marital status</label>
                                                <select className="form-select" value={mStatus} onChange={(e)=>setMStatus(e.target.value)}>
                                                <option value=''></option>
                                                  {(maritalOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Religion</label>
                                                <select className="form-select" value={religion} onChange={(e)=>setReligion(e.target.value)}>
                                                  <option value=''></option>
                                                  {(religionOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Nationality</label>
                                                <select className="form-select" disabled={true} value={nationality} onChange={(e)=>setNationality(e.target.value)}>
                                                  <option value=''></option>
                                                  {(nationalityOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12} className="d-flex justify-content-center">
                                    <div className="col-auto me-2 mb-2">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={handleUpdate}>
                                        <span>Update</span></Button>
                                    </div>
                                    
                                   
                                </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Address and Contacts</h6>
                                <CardBody>
                                <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Residential Address`}</label>
                                        <input type='text' className="form-control" value={residentialAddress} onChange={(e)=>setResidentialAddress(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Residential Phone`}</label>
                                        <input type='text' className="form-control" value={residentialPhone} onChange={(e)=>setResidentialPhone(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Cell/Mobile Phone`}</label>
                                        <input type='text' className="form-control" value={cellPhone} onChange={(e)=>setCellPhone(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Office Phone`}</label>
                                        <input type='text' className="form-control" value={officePhone} onChange={(e)=>setOfficePhone(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Email`}</label>
                                        <input type='text' className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={12} className="d-flex justify-content-center">
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={handleUpdate}>
                                        <span>Update</span></Button>
                                    </div>
                                </Col>
                                </Row>
                                </CardBody>
                            </Card>
                            
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Parents</h6>
                                <CardBody>
                                <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Mother's name`}</label>
                                        <input type='text' className="form-control" value={mother} onChange={(e)=>setMother(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Father's name`}</label>
                                        <input type='text' className="form-control" value={father} onChange={(e)=>setFather(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={12} className="d-flex justify-content-center">
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={handleUpdate}>
                                        <span>Update</span></Button>
                                    </div>
                                </Col>
                                </Row>
                                </CardBody>
                            </Card>

                            
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Health Data</h6>
                                <CardBody>
                                <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Blood Group`}</label>
                                        <select className="form-select" value={bloodGroup} onChange={(e)=>setBloodGroup(e.target.value)}>
                                            <option value=""></option>
                                            {(bloodOptions || []).map((r,k)=>(
                                                <option key={k} value={r}>{r}</option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Allergies`}</label>
                                        <input type='text' className="form-control" value={allergies} onChange={(e)=>setAllergies(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Personal Doctor`}</label>
                                        <input type='text' className="form-control" value={personalDoctor} onChange={(e)=>setPersonalDoctor(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={12} className="d-flex justify-content-center">
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={handleUpdate}>
                                        <span>Update</span></Button>
                                    </div>
                                </Col>
                                </Row>
                                   
                                </CardBody>
                            </Card>
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Next of Kin</h6>
                                <CardBody>
                                <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Next of kin name`}</label>
                                        <input type='text' className="form-control" value={kinName} onChange={(e)=>setKinName(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Next of kin relation`}</label>
                                        <select className="form-select" value={kinRelation} onChange={(e)=>setKinRelation(e.target.value)}>
                                        <option value=""></option>
                                        {(relationOptions || []).map((r,k)=>(
                                            <option key={k} value={r}>{r}</option>
                                        ))}
                                        </select>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Next of kin address`}</label>
                                        <input type='text' className="form-control" value={kinAddress} onChange={(e)=>setKinAddress(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Next of kin phone`}</label>
                                        <input type='text' className="form-control" value={kinPhone} onChange={(e)=>setKinPhone(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>{`Next of kin email`}</label>
                                        <input type='text' className="form-control" value={kinEmail} onChange={(e)=>setKinEmail(e.target.value)}/>
                                    </div>
                                </Col>
                                <Col md={12} className="d-flex justify-content-center">
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={handleUpdate}>
                                        <span>Update</span></Button>
                                    </div>
                                </Col>
                                </Row>
                                   
                                </CardBody>
                            </Card>

                            <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Files</h6>
                                    <CardBody>
                                        <Row className="justify-content-center">
                                            <Col md={12}>
                                      {(loadingFiles ? (
                                        <>
                                        <div className="text-center">
                                                    <div className="mb-4">
                                                    </div>
                                                    <div>
                                                    <h5>Loading files ...</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                        </>
                                    ): ((uploadedFiles.length > 0)?(
                                        <div className="table">
                                                <Table className="table table-striped table-sm mb-4">
                                                <thead>
                                                    <tr>
                                                    <th>No</th>
                                                    <th>Category</th>
                                                    <th>Name</th>
                                                    <th>File</th>
                                                    <th></th>
                                                    </tr>
                                                </thead>
                                                    <tbody>
                                      	                {uploadedFiles.map((a,k)=>(
                                                            <tr key={k}>
                                                              <td>{k+1}</td>
                                                              <td>{a.type}</td>
                                                              <td>{a.doc}</td>
                                                              <td><Link to="#" onClick={()=>handleDownload(uploadedFiles[k])}>{a.location}</Link></td>
                                                              <td style={{ verticalAlign: 'middle', textAlign: 'right' }}> <>
                                                                    <div className="d-flex gap-3">
                                                                   
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => removeFile(uploadedFiles[k])}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                    </></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No file attached</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )))}
                                            </Col>
                                            {(status != "Closed") && (
                                            <div className="col-auto">
                                              <Button
                                                color="primary" 
                                                className="btn-rounded btn-sm"
                                                onClick={() =>{ tog_file() }}
                                              >
                                                <span>Add file</span>{" "}
                                                <i className="mdi mdi-file" />
                                              </Button>
                                            </div>
                                            )}
                                        </Row>
                                    </CardBody>
                                </Card>
                                            
                               
                                    

                            </Col>
                            <Col xl={6}>
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Job</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eJHistory || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Date</th>
                                            <th>Title</th>
                                            <th>Dept</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eJHistory || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.date}</td>
                                                <td>{l.titleName}</td>
                                                <td>{l.deptName}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditJobH(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Job History</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_jhistory(); setIsEdit(false); setJobHDate([]); setJobHDept(''); setJobHLocation(''); setJobHTitle(''); setJobHType('') }}>
                                        <span>Add Job</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Salary</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eSalary || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Date</th>
                                            <th>Scale</th>
                                            <th>Basic Pay</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eSalary || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.date}</td>
                                                <td>{l.scale}</td>
                                                <td>{(parseFloat(l.basicPay) || 0).toLocaleString()}</td>
                                                {/*
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                            to="#"
                                                            className="text-success"
                                                            onClick={() =>{ tog_salary(); setIsEdit(true); setLineId(l.id); setSalaryId(l.scaleId); setSalaryDate([new Date(l.date)])}}
                                                            >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                            to="#"
                                                            className="text-danger"
                                                            onClick={() => handleDeleteScale(l)}
                                                            >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                    */}
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Salary Details</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    {/*
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_salary(); setIsEdit(false); setSalaryDate([]); setSalaryId(''); }}>
                                        <span>Add Salary</span></Button>
                                    </div> 
                                    */}
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Contracts</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((econtracts || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Type</th>
                                            <th>Contract No</th>
                                            <th>Start</th>
                                            <th>End</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(econtracts || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.type}</td>
                                                <td>{l.no}</td>
                                                <td>{l.start}</td>
                                                <td>{l.end}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditContract(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteContract(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Contracts</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_contracts(); setIsEdit(false); setContNo(''); setContFrom([]); setContTo([]) }}>
                                        <span>Add Contract</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Qualifications</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eEducation || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Level</th>
                                            <th>Qualification</th>
                                            <th>Institution</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eEducation || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.level}</td>
                                                <td>{l.qualification}</td>
                                                <td>{l.institution}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditEducation(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteEducation(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Qualifications</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_education(); setIsEdit(false); setLineId(''); setQualificationType(''); setQualificationName(''); setQualificationInstitution(''); setQualificationPeriod('') }}>
                                        <span>Add Qualification</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>
                          

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Dependants</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eDependants || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            <th>Relation</th>
                                            <th>Date of Birth</th>
                                            <th>Medical</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eDependants || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.name}</td>
                                                <td>{l.type}</td>
                                                <td>{l.dob}</td>
                                                <td>{l.onMedical}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditDependants(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteDependant(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                            </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No dependants</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_dependant(); setIsEdit(false); setDependantName(''); setDependantBirthdate([]); setDependantGender(''); setDependantRelation(''); }}>
                                        <span>Add Dependant</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                                                
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Skills</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eSkills || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Description</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eSkills || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.skill}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditSkill(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteSkill(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Skills</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_skills(); setIsEdit(false); setSkillName('') }}>
                                        <span>Add Skill</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>
                          

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Licenses</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eLicenses || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>License</th>
                                            <th>Issued</th>
                                            <th>Expiry</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eLicenses || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.licence} - {l.no}</td>
                                                <td>{l.issuedOn}</td>
                                                <td>{l.expireOn}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditLicense(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteLicense(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                            </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Licences</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_licenses(); setIsEdit(false); setLicenseExpiryDate([]); setLicenseIssueDate([]); setLicenseName(''); setLicenseNo('') }}>
                                        <span>Add Licences</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Working Experience</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eExperience || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Position</th>
                                            <th>Name</th>
                                            
                                            <th>From-To</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eExperience || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.position}</td>
                                                <td>{l.employer}</td>
                                                
                                                <td>{l.from.split("-")[0]} - {l.to.split("-")[0]}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditExperience(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteExperience(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                            </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Experience</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_experience(); setIsEdit(false); setExpCompanyName(''); setExpCompanyType(''); setExpPosition(''); setExpFrom(''); setExpTo('') }}>
                                        <span>Add Experience</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>
                           

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Memberships</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eMemberships || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Body</th>
                                            <th>Reg No</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eMemberships || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.organisation}</td>
                                                <td>{l.regno}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditMembership(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteMembership(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                            </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Memberships</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_memberships(); setIsEdit(false); setMembershipBody(''); setMembershipNo('')}}>
                                        <span>Add Membership</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>
                           
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Passports</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((ePassports || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Passport No</th>
                                            <th>Type</th>
                                            <th>Expiry Date</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(ePassports || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.no}</td>
                                                <td>{l.type}</td>
                                                <td>{l.expireOn}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditPassport(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeletePassport(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                            </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Passport</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_passports(); setIsEdit(false); setPassNo(''); setPassType(''); setPassIssuePlace(''); setPassIssuedate([]); setPassExpiredate([])}}>
                                        <span>Add Passport</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Assets Assigned to Employee</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eAssets || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Asset Name</th>
                                            <th>Date Assigned</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eAssets || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.equipment}</td>
                                                <td>{l.dateAssigned}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() =>{ tog_asset(); setIsEdit(true); setLineId(l.id); setAssetName(l.equipment); setAssetDetails(l.details); setAssetDate([new Date(l.dateAssigned)])}}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteAsset(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                            </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Company Assets</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_asset(); setIsEdit(false); setAssetDate([]); setAssetName(''); setAssetDetails('') }}>
                                        <span>Add Passport</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>


                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Languages</h6>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((eLanguages || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Language</th>
                                            <th>Proficiency</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(eLanguages || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.language}</td>
                                                <td>{l.proficiency}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => handleEditLanguage(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteLanguage(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Languages</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" onClick={() =>{ tog_language(); setIsEdit(false); setLangName(''); setLangProf('') }}>
                                        <span>Add Language</span></Button>
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card> 
                            </Col>
                            </>):(
                                <>
                                  <Alert color="danger"><i className="mdi mdi-bullseye-arrow me-2"></i><strong> Your user account is not connected to any Human Resource Data! Contact System Administrator </strong></Alert>  
                                </>
                            )}
                           
                        </Row>
                    </div>
                </Container>  
            </div>
            </LoadingOverlay>
        </>
    );
}

export default PersonalData;